function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMyAccount = function SvgMyAccount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 500 500"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M-.04.24h500.3v500.55H-.04z",
    style: {
      fill: "#0054a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.33 98.69c-83.06 0-150.64 67.58-150.64 150.64a150.3 150.3 0 0 0 52 113.68 6.3 6.3 0 0 0 1.4 1.21 150.22 150.22 0 0 0 153.81 24.72 59.57 59.57 0 0 0 83.07-83.07 149.4 149.4 0 0 0 11-56.54C400 166.27 332.4 98.69 249.33 98.69ZM112.08 249.33c0-75.68 61.57-137.25 137.25-137.25s137.26 61.57 137.26 137.25a136.2 136.2 0 0 1-7.77 45.49 59.33 59.33 0 0 0-78.28 1.18 104.5 104.5 0 0 0-19.2-8.39 66 66 0 1 0-63.94 0 105.36 105.36 0 0 0-64.48 59.27 136.83 136.83 0 0 1-40.84-97.55Zm137.25 33.18h-.07a52.64 52.64 0 1 1 .15 0Zm-85.72 73.89a91.63 91.63 0 0 1 85.65-60.5h.15a90.9 90.9 0 0 1 42 10.34 59.37 59.37 0 0 0 3.41 72.58 136.87 136.87 0 0 1-131.21-22.42Zm176.7 30.19a46.27 46.27 0 1 1 46.28-46.27 46.33 46.33 0 0 1-46.28 46.27Z",
    style: {
      fill: "#fff",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: "2.83px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.85 315a6.69 6.69 0 0 0-9.34 1.55l-23.74 33.23-16.72-16.68a6.7 6.7 0 0 0-9.47 9.47l22.31 22.31a6.7 6.7 0 0 0 4.74 2h.55a6.71 6.71 0 0 0 4.9-2.78l28.32-39.66a6.69 6.69 0 0 0-1.55-9.44Z",
    style: {
      strokeMiterlimit: 10,
      strokeWidth: "2.83px",
      fill: "#fd0",
      stroke: "#fd0"
    }
  }));
};
export default SvgMyAccount;